import React from 'react';
import { Col, Row } from 'antd';
import filterItemRemoveIcon from 'images/filter-item-remove-icon.png';
import { Normal } from 'components/Typography';

import { Container } from './styles';

const ToolboxSplashFiltersList = ({ filters, handleListItemClick, isSelected }) => {
  return (
    <Container>
      <Row gutter={[0, 16]} type="flex">
        {filters.map(filter => {
          return (
            <Col span={24}>
              <Normal className="toolbox-details-filters-list--title">
                <b>{filter.title}</b>
              </Normal>
              {filter.list.map(listItem => {
                return (
                  <Normal
                    className={`toolbox-details-filters-list--list-item ${isSelected(listItem) &&
                      'selected'}`}
                    onClick={() => handleListItemClick(listItem, filter.category)}
                  >
                    {listItem}{' '}
                    {isSelected(listItem) && (
                      <img
                        src={filterItemRemoveIcon}
                        className="toolbox-details-filters-list--remove-filter-icon"
                      />
                    )}
                  </Normal>
                );
              })}
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default ToolboxSplashFiltersList;
